import React, { useState, useEffect } from 'react';
import { Menu, X } from 'lucide-react';
import { useLang } from '../context/LanguageContext';

export default function Navbar() {
  const { lang, t, toggle } = useLang();
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);

  useEffect(() => {
    const handler = () => setScrolled(window.scrollY > 40);
    window.addEventListener('scroll', handler);
    return () => window.removeEventListener('scroll', handler);
  }, []);

  const scrollTo = (id) => {
    document.getElementById(id)?.scrollIntoView({ behavior: 'smooth' });
    setMobileOpen(false);
  };

  const navLinks = [
    { id: 'hero',        label: t.nav.home },
    { id: 'products',    label: t.nav.products },
    { id: 'product',     label: t.nav.product },
    { id: 'facewash',    label: t.nav.facewash },
    { id: 'order',       label: t.nav.order },
  ];

  return (
    <header className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${scrolled ? 'bg-white/96 backdrop-blur-md border-b border-gray-100 shadow-sm' : 'bg-transparent'}`}>
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="flex items-center justify-between h-16 md:h-20">
          {/* Logo */}
          <button onClick={() => scrollTo('hero')} className="flex flex-col items-start leading-none">
            <span className="font-display text-xl md:text-2xl font-bold tracking-widest text-misky-black uppercase">MISKY</span>
            <span className="text-[9px] tracking-[0.15em] text-misky-mid uppercase" style={{ letterSpacing: '0.15em' }}>Ceramide Complex 2%</span>
          </button>

          {/* Desktop Nav */}
          <nav className="hidden md:flex items-center gap-8">
            {navLinks.map((l) => (
              <button key={l.id} onClick={() => scrollTo(l.id)}
                className="text-sm font-medium text-misky-gray hover:text-misky-black transition-colors tracking-wide">
                {l.label}
              </button>
            ))}
          </nav>

          {/* Right controls */}
          <div className="flex items-center gap-3">
            {/* Language Toggle */}
            <button
              onClick={toggle}
              className="flex items-center gap-1.5 border border-misky-black/20 text-misky-gray hover:border-misky-black hover:text-misky-black px-3 py-1.5 rounded-full text-xs font-medium transition-all"
            >
              <span className="text-base leading-none">{lang === 'en' ? '🇯🇴' : '🇬🇧'}</span>
              <span>{lang === 'en' ? 'عربي' : 'English'}</span>
            </button>

            <button
              onClick={() => scrollTo('order')}
              className="hidden sm:flex items-center bg-misky-black text-white px-5 py-2 rounded-full text-sm font-medium hover:bg-misky-dark transition-colors"
            >
              {t.nav.order}
            </button>

            <button className="md:hidden p-2" onClick={() => setMobileOpen(!mobileOpen)}>
              {mobileOpen ? <X className="w-5 h-5" /> : <Menu className="w-5 h-5" />}
            </button>
          </div>
        </div>

        {/* Mobile Menu */}
        {mobileOpen && (
          <div className="md:hidden py-4 border-t border-gray-100 bg-white animate-fade-in">
            {navLinks.map((l) => (
              <button key={l.id} onClick={() => scrollTo(l.id)}
                className="block w-full text-right px-4 py-3 text-misky-gray hover:text-misky-black hover:bg-gray-50 transition-colors font-medium">
                {l.label}
              </button>
            ))}
            <div className="px-4 pt-3 border-t border-gray-100 mt-2">
              <button onClick={toggle}
                className="flex items-center gap-2 text-sm text-misky-gray border border-misky-black/20 px-3 py-1.5 rounded-full">
                <span>{lang === 'en' ? '🇯🇴' : '🇬🇧'}</span>
                <span>{lang === 'en' ? 'عربي' : 'English'}</span>
              </button>
            </div>
          </div>
        )}
      </div>
    </header>
  );
}
